import { Column, Divider, Row, Text } from '~/commonComponents';
import { JobPostingStatus } from '~/domain/PermanentJobs';
import { AlertCircleIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';

interface IClosedBannerProps {
  hasScheduledOnsiteInterviews: boolean;
  jobStatus: JobPostingStatus;
}

export const ClosedBanner = ({ hasScheduledOnsiteInterviews, jobStatus }: IClosedBannerProps) => {
  if (jobStatus !== JobPostingStatus.Closed) {
    return null;
  }

  return (
    <Row
      data-cy="closed-job-banner"
      alignItems="center"
      backgroundColor={Colors.neutral_50}
      borderColor={Colors.neutral_400}
      borderRadius={6}
      borderStyle="solid"
      borderWidth={1}
      gap={12}
      marginTop={20}
      paddingBlock={12}
      paddingInline={10}
    >
      <AlertCircleIcon color={Colors.neutral_400} size={24} />
      <Divider height="95%" width={1} color={Colors.neutral_400} />
      <Column>
        <Text bold color={Colors.neutral_600} marginBottom={4}>
          This Job Posting Is Closed:
        </Text>
        <Text color={Colors.neutral_600}>
          {hasScheduledOnsiteInterviews ? (
            <>
              Candidates can no longer view or apply to this job. Any onsite interviews already
              scheduled within 7 days of the closing date will remain active. All others have been
              canceled.
            </>
          ) : (
            <>
              Candidates can no longer view or apply to this job. You can still view and review its
              details anytime, but no additional actions can be taken.
            </>
          )}
        </Text>
      </Column>
    </Row>
  );
};
